<ng-container *ngIf="constant.IsVerified">
  <div class="col-md-12 slider-row">
    <!-- <ngx-slick-carousel class="carousel carousel-a" id="slickAModal" #slickAModal="slick-carousel"
      [config]="slideConfig">
      <ng-container *ngFor="let game of constant.gameList;let i=index">
        <ng-container *ngIf="game.GameCode.trim()=='TP' || game.GameCode.trim()=='DT'">
          <div ngxSlickItem class="slide" [ngClass]="{'selected-game': GameCode.trim() == 'W'+game.GameCode.trim() }"
            (click)="getGameUrl(game,i)">
            <div class="slide-game">
              <div class="slide-game-name">
                <span>{{game.Name}}</span>
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>

    </ngx-slick-carousel> -->
    <swiper [config]="config" class="mySwiper d-flex" [navigation]="true">
      <div *ngFor="let game of constant.gameList;let i=index">
        <ng-template swiperSlide>
          <div class="slide" [ngClass]="{'selected-game': GameCode.trim() == game.GameCode.trim() }">
            <div class="slide-game" (click)="getGameUrl(game,i)">
              <div class="slide-game-name">
                <span>{{game?.Name?.replaceAll('Virtual','RNG')}}</span>
              </div>
            </div>
          </div>
        </ng-template>
      </div>
    </swiper>

  </div>
</ng-container>

<ng-container *ngIf="transform && constant.IsVerified">
  <iframe scroll="no" sandbox="allow-same-origin allow-scripts allow-forms" [src]="transform"
    style="width: 100%;height: 70vh;" frameborder="0" allowfullscreen="true" webkitallowfullscreen="true"
    mozallowfullscreen="true" #gameFrame></iframe>
  <app-chips-setting [minStack]="10" [maxStack]="10000"></app-chips-setting>
</ng-container>